<!-- TODO :: adjust loading due to slight issue on initial load of property from external var  -->
<template>
  <div :class="{show: this.loaderVisible }" class="modal fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content loader-modal-content">
        <div class="modal-body loader-modal-body d-flex flex-column" v-if="loaderError">
          <h4 class="text-danger" v-html="$t('flexben.general.server_error')"></h4>
          <button @click="close()" class="btn btn-themed mx-auto">{{ $t('flexben.general.btn.close') }}
          </button>
        </div>
        <div class="modal-body loader-modal-body" v-else>
          <img src="@/assets/images/loader-343px-343px.svg" class="loader-gif" alt="" />
          <p class="w-100 text-center">{{ $t('loadingPopupMessage') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loader',
  props: {
    loaderVisible: {type: Boolean, default: true},
    loaderError: {type: Boolean, default: false},
  },

  methods: {
    close() {
      if (typeof this.$parent.loading !== undefined) {
        this.$parent.loading = false;
        this.$parent.loaderError = false;
      } else {
        this.loaderVisible = false;
        this.loaderError = false;
      }
    }
  }
};
</script>
<style scoped src="../../../node_modules/bootstrap/dist/css/bootstrap.min.css"></style>
<style scoped lang="scss">
.modal {
  z-index: 31000;
  background: rgba(78, 91, 89, 0.9);
}

.loader-modal-content,
.loader-modal-body {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.loader-modal-body p {
  color: #fff;
}

.loader-gif {
  display: block;
  width: 343px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}
</style>
